var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_303_5662)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9997 17.1428C25.8929 17.1428 27.4283 15.6074 27.4283 13.7142C27.4283 11.821 25.8929 10.2856 23.9997 10.2856C22.1065 10.2856 20.5711 11.8178 20.5711 13.7142C20.5711 15.6106 22.1033 17.1428 23.9997 17.1428ZM28.2854 32.5714H26.5711V23.1428C26.5711 21.7285 25.4247 20.5714 23.9997 20.5714H20.5711C19.1569 20.5714 17.9997 21.7285 17.9997 23.1428C17.9997 24.5571 19.1569 25.7142 20.5711 25.7142H21.4283V32.5714H19.714C18.2997 32.5714 17.1426 33.7285 17.1426 35.1428C17.1426 36.5571 18.2997 37.7142 19.714 37.7142H28.2854C29.7051 37.7142 30.8569 36.5624 30.8569 35.1428C30.8569 33.7231 29.7104 32.5714 28.2854 32.5714Z",
    fill: "#0066FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M41.1429 0H6.85714C3.06964 0 0 3.06964 0 6.85714V41.1429C0 44.9293 3.06964 48 6.85714 48H41.1429C44.9304 48 48 44.9293 48 41.1429V6.85714C48 3.06964 44.925 0 41.1429 0ZM24 10.2857C25.8932 10.2857 27.4286 11.8211 27.4286 13.7143C27.4286 15.6075 25.8932 17.1429 24 17.1429C22.1068 17.1429 20.5714 15.6107 20.5714 13.7143C20.5714 11.8179 22.1036 10.2857 24 10.2857ZM28.2857 37.7143H19.7143C18.3 37.7143 17.1429 36.5679 17.1429 35.1429C17.1429 33.7179 18.2946 32.5714 19.7143 32.5714H21.4286V25.7143H20.5714C19.1518 25.7143 18 24.5625 18 23.1429C18 21.7232 19.1571 20.5714 20.5714 20.5714H24C25.4196 20.5714 26.5714 21.7232 26.5714 23.1429V32.5714H28.2857C29.7054 32.5714 30.8571 33.7232 30.8571 35.1429C30.8571 36.5625 29.7107 37.7143 28.2857 37.7143Z",
    fill: "#0066FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_303_5662"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.ac1535829295bbb2ed1237ad64bf315c.svg";
export { ForwardRef as ReactComponent };